export default {
    similarSessionApiUrl: 'https://similar-sessions-retriever.mysoluto.com',
};
